import { Box, InputAdornment, InputBase, Snackbar, Theme } from '@mui/material';
import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import MicIcon from '@mui/icons-material/Mic';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    searchBox: {
      display: 'flex',
      alignItems: 'center',
      // marginTop: theme.spacing(2),
      width: '260px',
      maxWidth: '100%',
      '@media (max-width: 600px)': {
        width: '100%',
      },
      '@media (min-width: 1920px) and (max-width: 1940px)': {
        width: '100%',
      },
      border: '0.38px solid #B2B3B7',
      borderRadius: '8px',
      // padding: 2,
    },
    inputBase: {
      backgroundColor: 'white',
      borderRadius: '5px',
      padding: theme.spacing(1),
      flexGrow: 1,
    },
  })
);

interface AppSearchBarProps {
  handleMicHold?: () => void;
  handleMicRelease?: () => void;
  localSearchInput: any;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  openSnackbar?: boolean;
  desktopWidth?: string;
}
const AppSearchBar: React.FC<AppSearchBarProps> = ({ handleMicHold, handleMicRelease, localSearchInput, handleChange, openSnackbar, desktopWidth = '260px' }) => {
  const classes = useStyles();
  const showMic = !!handleMicHold || !!handleMicRelease;

  const handleMicPressStart = (event?: React.MouseEvent | React.TouchEvent) => {
    event?.preventDefault();
    event?.stopPropagation();
    handleMicHold?.();
  };

  const handleMicPressEnd = (event?: React.MouseEvent | React.TouchEvent) => {
    event?.preventDefault();
    event?.stopPropagation();
    handleMicRelease?.();
  };

  return (
    <>
      <Box className={classes.searchBox} sx={{ width: { xs: '100%', sm: desktopWidth } }}>
        <InputBase
          sx={{
            borderRadius: '9px',
            height: '36px',
            fontSize: '12px',
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              height: '24px',
              fontSize: '10px !important',
              borderRadius: '9px',
            },
          }}
          placeholder="Search by keywords"
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon
                sx={{
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '15px !important',
                  },
                }}
              />
            </InputAdornment>
          }
          endAdornment={
            showMic ? (
              <InputAdornment
                position="end"
                style={{ cursor: 'pointer' }}
                onMouseDown={handleMicPressStart}
                onMouseUp={handleMicPressEnd}
                onMouseLeave={handleMicPressEnd}
                onTouchStart={handleMicPressStart}
                onTouchEnd={handleMicPressEnd}
                onTouchCancel={handleMicPressEnd}
              >
                <MicIcon
                  sx={{
                    color: openSnackbar ? 'red' : 'inherit',
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '15px !important',
                    },
                  }}
                />
              </InputAdornment>
            ) : undefined
          }
          className={classes.inputBase}
          value={localSearchInput}
          onChange={handleChange}
        />
      </Box>
      {showMic && <Snackbar open={!!openSnackbar} onClose={() => { }} message="Microphone is on. You can speak now." />}
    </>
  );
};

export default AppSearchBar;
